import React, { Component, ErrorInfo, ReactNode } from 'react';
import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';
import { ConfiguredToaster } from '@app/shared/ui/sonner';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    analytics.emitEvent('service_error_system', {
      [PlatformName.GTM]: {
        action: errorInfo.componentStack ?? 'react_error_boundary',
        message: error.message,
      },
    });

    ConfiguredToaster.toastUnknownError();
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <div />;
    }

    return this.props.children;
  }
}
